(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["qrs-enquiry-feedback"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('qrs-enquiry-feedback')) {
    customElements.define('qrs-enquiry-feedback', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.form = this.closest('form');
        if (!this.form) return;
        this.initialized = true;
        this.onSubmit = () => {
          clearTimeout(this.timer);
          this.hidden = false;
          this.removeAttribute('data-unconfirmed-visible');
          this.querySelector('[data-qrs-feedback-text]').textContent = this.dataset.pending;
          this.querySelector('[data-qrs-feedback-email]').hidden = true;
          this.timer = setTimeout(() => {
            if (!this.isConnected) return;
            this.form.querySelectorAll('button[type="submit"][aria-busy]').forEach(button => button.removeAttribute('aria-busy'));
            this.setAttribute('data-unconfirmed-visible', '');
            this.querySelector('[data-qrs-feedback-text]').textContent = this.dataset.unconfirmed + ' ';
            this.querySelector('[data-qrs-feedback-email]').hidden = false;
          }, 20000);
        };
        this.onPageHide = () => clearTimeout(this.timer);
        this.onPageShow = event => {
          if (!event.persisted) return;
          clearTimeout(this.timer);
          this.form.querySelectorAll('button[type="submit"][aria-busy]').forEach(button => button.removeAttribute('aria-busy'));
          this.removeAttribute('data-unconfirmed-visible');
          this.hidden = true;
        };
        this.form.addEventListener('submit', this.onSubmit, true);
        window.addEventListener('pagehide', this.onPageHide);
        window.addEventListener('pageshow', this.onPageShow);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.form?.removeEventListener('submit', this.onSubmit, true);
        window.removeEventListener('pagehide', this.onPageHide);
        window.removeEventListener('pageshow', this.onPageShow);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["qrs-enquiry-success"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('qrs-enquiry-success')) {
    customElements.define('qrs-enquiry-success', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const navigation = performance.getEntriesByType('navigation')[0];
        if (navigation && navigation.type !== 'navigate') return;
        if (document.querySelector('qrs-enquiry-success[data-shown]')) return;
        this.setAttribute('data-shown', '');
        this.hidden = false;
        this.frame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          const title = document.createElement('strong');
          const message = document.createElement('span');
          title.textContent = this.dataset.title;
          message.textContent = this.dataset.message;
          this.querySelector('.qrs-enquiry-success__copy').append(title, message);
          this.setAttribute('data-open', '');
          this.timer = setTimeout(() => this.dismiss(), 6000);
        });
        this.onPageShow = event => {
          if (event.persisted) this.dismiss();
        };
        window.addEventListener('pageshow', this.onPageShow);
      }
      dismiss() {
        clearTimeout(this.timer);
        this.removeAttribute('data-open');
        this.hideTimer = setTimeout(() => { this.hidden = true; }, 200);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.timer);
        clearTimeout(this.hideTimer);
        window.removeEventListener('pageshow', this.onPageShow);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
